import React from 'react'
import classnames from 'classnames'

type StateIndicatorProps = {
  isOpen?: boolean
}

const StateIndicator: React.FC<StateIndicatorProps> = ({ isOpen = false }) => {
  const classname = classnames('state-indicator', {
    'state-indicator--is-open': isOpen,
  })

  return <span className={classname}>▾</span>
}

export default StateIndicator
